<template>
  <button
    type="button"
    :disabled="disabled"
    :class="{
      'option-card': true,
      'option-card--active': active,
      'option-card--disabled': disabled,
    }"
    @click="$emit('click')"
  >
    <bg-icon v-if="icon" :name="icon" size="sm" />

    <slot>
      <bg-text size="body-3">{{ label }}</bg-text>
    </slot>

    <bg-text v-if="description" size="body-4" class="bg-u-text-neutral-500">
      {{ description }}
    </bg-text>
  </button>
</template>

<script>
import { BgText, BgIcon } from 'bangul-vue';

export default {
  name: 'OptionCard',

  components: {
    BgText,
    BgIcon,
  },

  props: {
    label: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped src="./OptionCard.scss" />
